import ScopeStackModal from "@components/ScopeStackModal/ScopeStackModal";

interface Props {
  show: boolean;
  credentialName: string;
  onClose: () => void;
  onConfirm: () => void;
  isRotating: boolean;
}

const RotateConfirmModal = ({
  show,
  credentialName,
  onClose,
  onConfirm,
  isRotating,
}: Props): JSX.Element => {
  const body = (
    <>
      <p>
        Rotating the secret for <strong>{credentialName}</strong> will
        immediately revoke every access token issued against this credential.
        Any integration using the current secret will need to be updated with
        the new one.
      </p>
      <p>Continue?</p>
    </>
  );

  return (
    <ScopeStackModal
      show={show}
      modalTitle="Rotate Client Secret"
      modalBody={body}
      handleClose={onClose}
      button1Text="Cancel"
      handleButton1Click={onClose}
      button2Text={isRotating ? "Rotating…" : "Rotate Secret"}
      handleButton2Click={onConfirm}
      button2Disabled={isRotating}
    />
  );
};

export default RotateConfirmModal;
